/******************************************************************************
 * This file was generated by langium-cli 3.3.0.
 * DO NOT EDIT MANUALLY!
 ******************************************************************************/

/* eslint-disable */
import type { AstNode, Reference, ReferenceInfo, TypeMetaData } from 'langium';
import { AbstractAstReflection } from 'langium';

export const MermaidTerminals = {
    ACC_DESCR: /[\t ]*accDescr(?:[\t ]*:([^\n\r]*?(?=%%)|[^\n\r]*)|\s*{([^}]*)})/,
    ACC_TITLE: /[\t ]*accTitle[\t ]*:(?:[^\n\r]*?(?=%%)|[^\n\r]*)/,
    TITLE: /[\t ]*title(?:[\t ][^\n\r]*?(?=%%)|[\t ][^\n\r]*|)/,
    NEWLINE: /\r?\n/,
    WHITESPACE: /[\t ]+/,
    YAML: /---[\t ]*\r?\n(?:[\S\s]*?\r?\n)?---(?:\r?\n|(?!\S))/,
    DIRECTIVE: /[\t ]*%%{[\S\s]*?}%%(?:\r?\n|(?!\S))/,
    SINGLE_LINE_COMMENT: /[\t ]*%%[^\n\r]*/,
    INT: /0|[1-9][0-9]*(?!\.)/,
    STRING: /"([^"\\]|\\.)*"|'([^'\\]|\\.)*'/,
    NUMBER_PIE: /((-?[0-9]+\.[0-9]+(?!\.))|(-?(0|[1-9][0-9]*)(?!\.)))/,
    ARROW_DIRECTION: /(((L|R)|T)|B)/,
    ARROW_GROUP: /\{group\}/,
    ARROW_INTO: /<|>/,
    ID: /[\w]([-\w]*\w)?/,
    ARCH_ICON: /\([\w-:]+\)/,
    ARCH_TITLE: /\[[\w ]+\]/,
    REFERENCE: /\w([-\./\w]*[-\w])?/,
    GRATICULE: /(circle|polygon)/,
    BOOLEAN: /(true|false)/,
    NUMBER: /(([0-9]+\.[0-9]+(?!\.))|(0|[1-9][0-9]*(?!\.)))/,
    TREEMAP_KEYWORD: /(treemap-beta|treemap)/,
    CLASS_DEF: /classDef\s+([a-zA-Z_][a-zA-Z0-9_]+)(?:\s+([^;\r\n]*))?(?:;)?/,
    STYLE_SEPARATOR: /:::/,
    SEPARATOR: /:/,
    COMMA: /,/,
    WS: /[ \t]+/,
    ML_COMMENT: /\%\%[^\n]*/,
    NL: /\r?\n/,
    INDENTATION: /[ \t]{1,}/,
    ID2: /[a-zA-Z_][a-zA-Z0-9_]*/,
    NUMBER2: /[0-9_\.\,]+/,
    STRING2: /"[^"]*"|'[^']*'/,
};

export type MermaidTerminalNames = keyof typeof MermaidTerminals;

export type MermaidKeywordNames = 
    | "+"
    | ","
    | "-"
    | "--"
    | ":"
    | "BT"
    | "HIGHLIGHT"
    | "LR"
    | "NORMAL"
    | "REVERSE"
    | "TB"
    | "["
    | "]"
    | "architecture-beta"
    | "axis"
    | "branch"
    | "checkout"
    | "cherry-pick"
    | "commit"
    | "curve"
    | "gitGraph"
    | "gitGraph:"
    | "graticule"
    | "group"
    | "id:"
    | "in"
    | "info"
    | "junction"
    | "max"
    | "merge"
    | "min"
    | "msg:"
    | "order:"
    | "packet"
    | "packet-beta"
    | "parent:"
    | "pie"
    | "radar-beta"
    | "radar-beta:"
    | "service"
    | "showData"
    | "showInfo"
    | "showLegend"
    | "switch"
    | "tag:"
    | "ticks"
    | "type:"
    | "{"
    | "}";

export type MermaidTokenNames = MermaidTerminalNames | MermaidKeywordNames;

export type ClassDef = string;

export function isClassDef(item: unknown): item is ClassDef {
    return (typeof item === 'string' && (/classDef\s+([a-zA-Z_][a-zA-Z0-9_]+)(?:\s+([^;\r\n]*))?(?:;)?/.test(item)));
}

export type MyNumber = number;

export function isMyNumber(item: unknown): item is MyNumber {
    return typeof item === 'number';
}

export type Statement = Branch | Checkout | CherryPicking | Commit | Merge;

export const Statement = 'Statement';

export function isStatement(item: unknown): item is Statement {
    return reflection.isInstance(item, Statement);
}

export interface Architecture extends AstNode {
    readonly $type: 'Architecture';
    accDescr?: string;
    accTitle?: string;
    edges: Array<Edge>;
    groups: Array<Group>;
    junctions: Array<Junction>;
    services: Array<Service>;
    title?: string;
}

export const Architecture = 'Architecture';

export function isArchitecture(item: unknown): item is Architecture {
    return reflection.isInstance(item, Architecture);
}

export interface Axis extends AstNode {
    readonly $container: Radar;
    readonly $type: 'Axis';
    label?: string;
    name: string;
}

export const Axis = 'Axis';

export function isAxis(item: unknown): item is Axis {
    return reflection.isInstance(item, Axis);
}

export interface Branch extends AstNode {
    readonly $container: GitGraph;
    readonly $type: 'Branch';
    name: string;
    order?: number;
}

export const Branch = 'Branch';

export function isBranch(item: unknown): item is Branch {
    return reflection.isInstance(item, Branch);
}

export interface Checkout extends AstNode {
    readonly $container: GitGraph;
    readonly $type: 'Checkout';
    branch: string;
}

export const Checkout = 'Checkout';

export function isCheckout(item: unknown): item is Checkout {
    return reflection.isInstance(item, Checkout);
}

export interface CherryPicking extends AstNode {
    readonly $container: GitGraph;
    readonly $type: 'CherryPicking';
    id?: string;
    parent?: string;
    tags: Array<string>;
}

export const CherryPicking = 'CherryPicking';

export function isCherryPicking(item: unknown): item is CherryPicking {
    return reflection.isInstance(item, CherryPicking);
}

export interface ClassDefStatement extends AstNode {
    readonly $type: 'ClassDefStatement';
    className: string;
    styleText: string;
}

export const ClassDefStatement = 'ClassDefStatement';

export function isClassDefStatement(item: unknown): item is ClassDefStatement {
    return reflection.isInstance(item, ClassDefStatement);
}

export interface Commit extends AstNode {
    readonly $container: GitGraph;
    readonly $type: 'Commit';
    id?: string;
    message?: string;
    tags: Array<string>;
    type?: 'HIGHLIGHT' | 'NORMAL' | 'REVERSE';
}

export const Commit = 'Commit';

export function isCommit(item: unknown): item is Commit {
    return reflection.isInstance(item, Commit);
}

export interface Curve extends AstNode {
    readonly $container: Radar;
    readonly $type: 'Curve';
    entries: Array<Entry>;
    label?: string;
    name: string;
}

export const Curve = 'Curve';

export function isCurve(item: unknown): item is Curve {
    return reflection.isInstance(item, Curve);
}

export interface Edge extends AstNode {
    readonly $container: Architecture;
    readonly $type: 'Edge';
    lhsDir: string;
    lhsGroup: boolean;
    lhsId: string;
    lhsInto: boolean;
    rhsDir: string;
    rhsGroup: boolean;
    rhsId: string;
    rhsInto: boolean;
    title?: string;
}

export const Edge = 'Edge';

export function isEdge(item: unknown): item is Edge {
    return reflection.isInstance(item, Edge);
}

export interface Entry extends AstNode {
    readonly $container: Curve;
    readonly $type: 'Entry';
    axis?: Reference<Axis>;
    value: number;
}

export const Entry = 'Entry';

export function isEntry(item: unknown): item is Entry {
    return reflection.isInstance(item, Entry);
}

export interface GitGraph extends AstNode {
    readonly $type: 'Direction' | 'GitGraph';
    accDescr?: string;
    accTitle?: string;
    statements: Array<Statement>;
    title?: string;
}

export const GitGraph = 'GitGraph';

export function isGitGraph(item: unknown): item is GitGraph {
    return reflection.isInstance(item, GitGraph);
}

export interface Group extends AstNode {
    readonly $container: Architecture;
    readonly $type: 'Group';
    icon?: string;
    id: string;
    in?: string;
    title?: string;
}

export const Group = 'Group';

export function isGroup(item: unknown): item is Group {
    return reflection.isInstance(item, Group);
}

export interface Info extends AstNode {
    readonly $type: 'Info';
    accDescr?: string;
    accTitle?: string;
    title?: string;
}

export const Info = 'Info';

export function isInfo(item: unknown): item is Info {
    return reflection.isInstance(item, Info);
}

export interface Item extends AstNode {
    readonly $type: 'Item' | 'Leaf' | 'Section';
    classSelector?: string;
    name: string;
}

export const Item = 'Item';

export function isItem(item: unknown): item is Item {
    return reflection.isInstance(item, Item);
}

export interface Junction extends AstNode {
    readonly $container: Architecture;
    readonly $type: 'Junction';
    id: string;
    in?: string;
}

export const Junction = 'Junction';

export function isJunction(item: unknown): item is Junction {
    return reflection.isInstance(item, Junction);
}

export interface Merge extends AstNode {
    readonly $container: GitGraph;
    readonly $type: 'Merge';
    branch: string;
    id?: string;
    tags: Array<string>;
    type?: 'HIGHLIGHT' | 'NORMAL' | 'REVERSE';
}

export const Merge = 'Merge';

export function isMerge(item: unknown): item is Merge {
    return reflection.isInstance(item, Merge);
}

export interface Option extends AstNode {
    readonly $container: Radar;
    readonly $type: 'Option';
    name: 'graticule' | 'max' | 'min' | 'showLegend' | 'ticks';
    value: boolean | number | string;
}

export const Option = 'Option';

export function isOption(item: unknown): item is Option {
    return reflection.isInstance(item, Option);
}

export interface Packet extends AstNode {
    readonly $type: 'Packet';
    accDescr?: string;
    accTitle?: string;
    blocks: Array<PacketBlock>;
    title?: string;
}

export const Packet = 'Packet';

export function isPacket(item: unknown): item is Packet {
    return reflection.isInstance(item, Packet);
}

export interface PacketBlock extends AstNode {
    readonly $container: Packet;
    readonly $type: 'PacketBlock';
    bits?: number;
    end?: number;
    label: string;
    start?: number;
}

export const PacketBlock = 'PacketBlock';

export function isPacketBlock(item: unknown): item is PacketBlock {
    return reflection.isInstance(item, PacketBlock);
}

export interface Pie extends AstNode {
    readonly $type: 'Pie';
    accDescr?: string;
    accTitle?: string;
    sections: Array<PieSection>;
    showData: boolean;
    title?: string;
}

export const Pie = 'Pie';

export function isPie(item: unknown): item is Pie {
    return reflection.isInstance(item, Pie);
}

export interface PieSection extends AstNode {
    readonly $container: Pie;
    readonly $type: 'PieSection';
    label: string;
    value: number;
}

export const PieSection = 'PieSection';

export function isPieSection(item: unknown): item is PieSection {
    return reflection.isInstance(item, PieSection);
}

export interface Radar extends AstNode {
    readonly $type: 'Radar';
    accDescr?: string;
    accTitle?: string;
    axes: Array<Axis>;
    curves: Array<Curve>;
    options: Array<Option>;
    title?: string;
}

export const Radar = 'Radar';

export function isRadar(item: unknown): item is Radar {
    return reflection.isInstance(item, Radar);
}

export interface Service extends AstNode {
    readonly $container: Architecture;
    readonly $type: 'Service';
    icon?: string;
    iconText?: string;
    id: string;
    in?: string;
    title?: string;
}

export const Service = 'Service';

export function isService(item: unknown): item is Service {
    return reflection.isInstance(item, Service);
}

export interface Treemap extends AstNode {
    readonly $type: 'Treemap';
    accDescr?: string;
    accTitle?: string;
    title?: string;
    TreemapRows: Array<TreemapRow>;
}

export const Treemap = 'Treemap';

export function isTreemap(item: unknown): item is Treemap {
    return reflection.isInstance(item, Treemap);
}

export interface TreemapRow extends AstNode {
    readonly $container: Treemap;
    readonly $type: 'ClassDef' | 'TreemapRow';
    indent?: string;
    item: Item;
}

export const TreemapRow = 'TreemapRow';

export function isTreemapRow(item: unknown): item is TreemapRow {
    return reflection.isInstance(item, TreemapRow);
}

export interface Direction extends GitGraph {
    readonly $type: 'Direction';
    dir: 'BT' | 'LR' | 'TB';
}

export const Direction = 'Direction';

export function isDirection(item: unknown): item is Direction {
    return reflection.isInstance(item, Direction);
}

export interface Leaf extends Item {
    readonly $type: 'Leaf';
    value: number;
}

export const Leaf = 'Leaf';

export function isLeaf(item: unknown): item is Leaf {
    return reflection.isInstance(item, Leaf);
}

export interface Section extends Item {
    readonly $type: 'Section';
}

export const Section = 'Section';

export function isSection(item: unknown): item is Section {
    return reflection.isInstance(item, Section);
}

export type MermaidAstType = {
    Architecture: Architecture
    Axis: Axis
    Branch: Branch
    Checkout: Checkout
    CherryPicking: CherryPicking
    ClassDefStatement: ClassDefStatement
    Commit: Commit
    Curve: Curve
    Direction: Direction
    Edge: Edge
    Entry: Entry
    GitGraph: GitGraph
    Group: Group
    Info: Info
    Item: Item
    Junction: Junction
    Leaf: Leaf
    Merge: Merge
    Option: Option
    Packet: Packet
    PacketBlock: PacketBlock
    Pie: Pie
    PieSection: PieSection
    Radar: Radar
    Section: Section
    Service: Service
    Statement: Statement
    Treemap: Treemap
    TreemapRow: TreemapRow
}

export class MermaidAstReflection extends AbstractAstReflection {

    getAllTypes(): string[] {
        return [Architecture, Axis, Branch, Checkout, CherryPicking, ClassDefStatement, Commit, Curve, Direction, Edge, Entry, GitGraph, Group, Info, Item, Junction, Leaf, Merge, Option, Packet, PacketBlock, Pie, PieSection, Radar, Section, Service, Statement, Treemap, TreemapRow];
    }

    protected override computeIsSubtype(subtype: string, supertype: string): boolean {
        switch (subtype) {
            case Branch:
            case Checkout:
            case CherryPicking:
            case Commit:
            case Merge: {
                return this.isSubtype(Statement, supertype);
            }
            case Direction: {
                return this.isSubtype(GitGraph, supertype);
            }
            case Leaf:
            case Section: {
                return this.isSubtype(Item, supertype);
            }
            default: {
                return false;
            }
        }
    }

    getReferenceType(refInfo: ReferenceInfo): string {
        const referenceId = `${refInfo.container.$type}:${refInfo.property}`;
        switch (referenceId) {
            case 'Entry:axis': {
                return Axis;
            }
            default: {
                throw new Error(`${referenceId} is not a valid reference id.`);
            }
        }
    }

    getTypeMetaData(type: string): TypeMetaData {
        switch (type) {
            case Architecture: {
                return {
                    name: Architecture,
                    properties: [
                        { name: 'accDescr' },
                        { name: 'accTitle' },
                        { name: 'edges', defaultValue: [] },
                        { name: 'groups', defaultValue: [] },
                        { name: 'junctions', defaultValue: [] },
                        { name: 'services', defaultValue: [] },
                        { name: 'title' }
                    ]
                };
            }
            case Axis: {
                return {
                    name: Axis,
                    properties: [
                        { name: 'label' },
                        { name: 'name' }
                    ]
                };
            }
            case Branch: {
                return {
                    name: Branch,
                    properties: [
                        { name: 'name' },
                        { name: 'order' }
                    ]
                };
            }
            case Checkout: {
                return {
                    name: Checkout,
                    properties: [
                        { name: 'branch' }
                    ]
                };
            }
            case CherryPicking: {
                return {
                    name: CherryPicking,
                    properties: [
                        { name: 'id' },
                        { name: 'parent' },
                        { name: 'tags', defaultValue: [] }
                    ]
                };
            }
            case ClassDefStatement: {
                return {
                    name: ClassDefStatement,
                    properties: [
                        { name: 'className' },
                        { name: 'styleText' }
                    ]
                };
            }
            case Commit: {
                return {
                    name: Commit,
                    properties: [
                        { name: 'id' },
                        { name: 'message' },
                        { name: 'tags', defaultValue: [] },
                        { name: 'type' }
                    ]
                };
            }
            case Curve: {
                return {
                    name: Curve,
                    properties: [
                        { name: 'entries', defaultValue: [] },
                        { name: 'label' },
                        { name: 'name' }
                    ]
                };
            }
            case Edge: {
                return {
                    name: Edge,
                    properties: [
                        { name: 'lhsDir' },
                        { name: 'lhsGroup', defaultValue: false },
                        { name: 'lhsId' },
                        { name: 'lhsInto', defaultValue: false },
                        { name: 'rhsDir' },
                        { name: 'rhsGroup', defaultValue: false },
                        { name: 'rhsId' },
                        { name: 'rhsInto', defaultValue: false },
                        { name: 'title' }
                    ]
                };
            }
            case Entry: {
                return {
                    name: Entry,
                    properties: [
                        { name: 'axis' },
                        { name: 'value' }
                    ]
                };
            }
            case GitGraph: {
                return {
                    name: GitGraph,
                    properties: [
                        { name: 'accDescr' },
                        { name: 'accTitle' },
                        { name: 'statements', defaultValue: [] },
                        { name: 'title' }
                    ]
                };
            }
            case Group: {
                return {
                    name: Group,
                    properties: [
                        { name: 'icon' },
                        { name: 'id' },
                        { name: 'in' },
                        { name: 'title' }
                    ]
                };
            }
            case Info: {
                return {
                    name: Info,
                    properties: [
                        { name: 'accDescr' },
                        { name: 'accTitle' },
                        { name: 'title' }
                    ]
                };
            }
            case Item: {
                return {
                    name: Item,
                    properties: [
                        { name: 'classSelector' },
                        { name: 'name' }
                    ]
                };
            }
            case Junction: {
                return {
                    name: Junction,
                    properties: [
                        { name: 'id' },
                        { name: 'in' }
                    ]
                };
            }
            case Merge: {
                return {
                    name: Merge,
                    properties: [
                        { name: 'branch' },
                        { name: 'id' },
                        { name: 'tags', defaultValue: [] },
                        { name: 'type' }
                    ]
                };
            }
            case Option: {
                return {
                    name: Option,
                    properties: [
                        { name: 'name' },
                        { name: 'value', defaultValue: false }
                    ]
                };
            }
            case Packet: {
                return {
                    name: Packet,
                    properties: [
                        { name: 'accDescr' },
                        { name: 'accTitle' },
                        { name: 'blocks', defaultValue: [] },
                        { name: 'title' }
                    ]
                };
            }
            case PacketBlock: {
                return {
                    name: PacketBlock,
                    properties: [
                        { name: 'bits' },
                        { name: 'end' },
                        { name: 'label' },
                        { name: 'start' }
                    ]
                };
            }
            case Pie: {
                return {
                    name: Pie,
                    properties: [
                        { name: 'accDescr' },
                        { name: 'accTitle' },
                        { name: 'sections', defaultValue: [] },
                        { name: 'showData', defaultValue: false },
                        { name: 'title' }
                    ]
                };
            }
            case PieSection: {
                return {
                    name: PieSection,
                    properties: [
                        { name: 'label' },
                        { name: 'value' }
                    ]
                };
            }
            case Radar: {
                return {
                    name: Radar,
                    properties: [
                        { name: 'accDescr' },
                        { name: 'accTitle' },
                        { name: 'axes', defaultValue: [] },
                        { name: 'curves', defaultValue: [] },
                        { name: 'options', defaultValue: [] },
                        { name: 'title' }
                    ]
                };
            }
            case Service: {
                return {
                    name: Service,
                    properties: [
                        { name: 'icon' },
                        { name: 'iconText' },
                        { name: 'id' },
                        { name: 'in' },
                        { name: 'title' }
                    ]
                };
            }
            case Treemap: {
                return {
                    name: Treemap,
                    properties: [
                        { name: 'accDescr' },
                        { name: 'accTitle' },
                        { name: 'title' },
                        { name: 'TreemapRows', defaultValue: [] }
                    ]
                };
            }
            case TreemapRow: {
                return {
                    name: TreemapRow,
                    properties: [
                        { name: 'indent' },
                        { name: 'item' }
                    ]
                };
            }
            case Direction: {
                return {
                    name: Direction,
                    properties: [
                        { name: 'accDescr' },
                        { name: 'accTitle' },
                        { name: 'dir' },
                        { name: 'statements', defaultValue: [] },
                        { name: 'title' }
                    ]
                };
            }
            case Leaf: {
                return {
                    name: Leaf,
                    properties: [
                        { name: 'classSelector' },
                        { name: 'name' },
                        { name: 'value' }
                    ]
                };
            }
            case Section: {
                return {
                    name: Section,
                    properties: [
                        { name: 'classSelector' },
                        { name: 'name' }
                    ]
                };
            }
            default: {
                return {
                    name: type,
                    properties: []
                };
            }
        }
    }
}

export const reflection = new MermaidAstReflection();
